import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Leaderboard from './Leaderboard';
import LogoImage from './Logo1.png';
import MFGif from './MF.gif';

const LeaderboardPage = () => {
    const navigate = useNavigate();
    const [scores, setScores] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('http://localhost:3001/scores')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Format scores to two decimal places and sort in descending order
                const formattedScores = data.map(score => ({
                    ...score,
                    score: parseFloat(score.score).toFixed(2)
                })).sort((a, b) => b.score - a.score);

                // Take the top 10 scores
                const topScores = formattedScores.slice(0, 10);
                setScores(topScores);
            })
            .catch(error => {
                console.error('Error fetching scores:', error);
                setError(error.toString());
            });
    }, []);

    const handleClose = () => {
        navigate('/game');
    };

    return (
        <div style={{ backgroundColor: '#279c8c', height: '100vh', position: 'relative' }}>
            <img src={LogoImage} alt="Logo" style={{
                position: 'absolute',
                top: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '700px',
                height: '250px'
            }} />
            <img src={MFGif} alt="Animated GIF" style={{
                position: 'absolute',
                right: '10px',
                bottom: '10px',
                width: '800px',
                height: '800px'
            }} />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
            }}>
                {error ? <p>Error loading scores: {error}</p> : <Leaderboard scores={scores} />}
                <button onClick={handleClose} style={{ fontSize: '20px', marginTop: '20px' }}>
                    Exit
                </button>
            </div>
        </div>
    );
};

export default LeaderboardPage;
